/**
 * Pre-Maintenance Banner Component
 *
 * Yellow warning banner shown when maintenance is preparing.
 * Displayed at the top of the landing page to warn users.
 */

import { memo } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export const PreMaintenanceBanner = memo(function PreMaintenanceBanner() {
  const { t } = useTranslation();

  return (
    <motion.div
      className="absolute top-0 left-0 right-0 z-50 bg-yellow-500 px-4 py-2"
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <div className="flex items-center justify-center gap-2">
        {/* Warning Icon */}
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="flex-shrink-0"
        >
          <path
            d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64 18.3 1.55 18.65 1.55 19C1.55 19.35 1.64 19.7 1.82 20C2.0 20.3 2.26 20.56 2.57 20.74C2.88 20.92 3.23 21.01 3.58 21H20.42C20.77 21.01 21.12 20.92 21.43 20.74C21.74 20.56 22 20.3 22.18 20C22.36 19.7 22.45 19.35 22.45 19C22.45 18.65 22.36 18.3 22.18 18L13.71 3.86C13.53 3.56 13.27 3.32 12.96 3.15C12.65 2.98 12.3 2.89 11.95 2.89C11.6 2.89 11.25 2.98 10.94 3.15C10.63 3.32 10.37 3.56 10.19 3.86L10.29 3.86Z"
            stroke="#000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <p className="font-mind-boggle text-sm text-black text-center leading-tight">
          {t('maintenance.preparing')}
        </p>
      </div>
    </motion.div>
  );
});

export default PreMaintenanceBanner;
